export enum OtherSettingsPermissions {
  Translation = 'translation',
  Setting = 'setting',
}
